import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useDashboard } from '../../context/DashboardContext';

const AuthModal = () => {
  const {
    showAuthModal,
    authTab,
    setAuthTab,
    login,
    closeAuthModal,
    pendingCitySelection,
    setPendingCitySelection
  } = useAuth();

  const { selectCity } = useDashboard();

  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginError('');
    
    const result = login(loginUsername.trim(), loginPassword);
    if (result.success) {
      const cityToProceed = pendingCitySelection;
      closeAuthModal(true);
      resetForms();
      if (cityToProceed) {
        selectCity(cityToProceed);
      }
    } else {
      setLoginError(result.error);
    }
  };

  const resetForms = () => {
    setLoginUsername('');
    setLoginPassword('');
    setLoginError('');
  };

  const handleTabSwitch = (tab) => {
    setAuthTab(tab);
    setLoginError('');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeAuthModal(true);
      resetForms();
    }
  };

  if (!showAuthModal) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="auth-modal-box">
        <button
          className="close-auth-modal"
          onClick={() => {
            closeAuthModal(true);
            resetForms();
          }}
        >
          &times;
        </button>

        <div className="auth-tabs">
          <button
            className={`auth-tab ${authTab === 'login' ? 'active' : ''}`}
            onClick={() => handleTabSwitch('login')}
          >
            Login
          </button>
        </div>

        {/* Login Form */}
        <form
          className={`auth-form ${authTab === 'login' ? 'active' : ''}`}
          onSubmit={handleLogin}
        >
          <div className="form-group">
            <label htmlFor="login-username">Username</label>
            <input
              type="text"
              id="login-username"
              value={loginUsername}
              onChange={(e) => setLoginUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <input
              type="password"
              id="login-password"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
              required
            />
          </div>
          {loginError && (
            <div className="error-message show">{loginError}</div>
          )}
          <button type="submit" className="auth-btn">Login</button>
        </form>
      </div>
    </div>
  );
};

export default AuthModal;

